module.exports = __webpack_public_path__ + "media/insights/football_icon-2f09a8bb.png";